import { clinicClient } from '@/common/apis/client';
import { useMutation } from '@tanstack/react-query';

export const sendDownloadLink = async (cell: string) => {
  const body = new URLSearchParams({ cell });
  const { data } = await clinicClient.post('/api/sendDownloadLinkApp', body);
  if (data?.status !== 1) throw new Error('send-download-link-failed');
  return data;
};

export const useSendDownloadLink = () => useMutation(sendDownloadLink);
